<template>
    <div class="role_list">
        <!-- 组织栏 -->
        <div class="role">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">公司</div>
            <div style="border: 1px solid #EEEEEE; border-radius: 10px;">
                <div v-for="(item,index) in departmentList" :key="index"
                     @click="chooseDepartment" :data-id="item.id"
					 :style="{'border-bottom': (index != departmentList.length - 1 ? '1px solid #eeeeee' : '')}"
                     style="display: flex; justify-content: space-between; align-items: center; padding: 10px; ">
                    <div class="hover_hand" :class="{'active': activeId == item.id}">{{item.name}}</div>
                    <div>
                        <span v-if="index != 0 && userInfo.menuList.homePage.organizationMember_saveDepartment" class="hover_hand fill icon iconfont icon-bianji"  @click.stop="editTissue"
                              :data-id="item.id" :data-name="item.name"></span>
                        <span v-if="index == 0 && userInfo.menuList.homePage.organizationMember_saveDepartment" class="hover_hand fill icon iconfont icon-jia" @click.stop="addTissue"></span>
                        <span v-if="index != 0 && userInfo.menuList.homePage.organizationMember_removeDepartment" class="hover_hand fill icon iconfont icon-jian" @click.stop="delTissue" :data-id="item.id"></span>
                    </div>
                </div>
            </div>
        </div>
		<!--div class="role">
		    <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">区部</div>
		    <div style="border: 1px solid #EEEEEE; border-radius: 10px;">
		        <div v-for="(item,index) in departmentList[0].children" :key="index"
		             @click="chooseDepartment" :data-id="item.id"
					 :style="{'border-bottom': (index != departmentList.length - 1 ? '1px solid #eeeeee' : '')}"
		             style="display: flex; justify-content: space-between; align-items: center; padding: 10px; ">
		            <div class="hover_hand" :class="{'active': activeId == item.id}">{{item.name}}</div>
					<div v-for="(item1,index1) in item.children" :key="index1"
					     @click="chooseDepartment" :data-id="item1.id"
						 :style="{'border-bottom': (index != departmentList.length - 1 ? '1px solid #eeeeee' : '')}"
					     style="display: flex; justify-content: space-between; align-items: center; padding: 10px; ">
						 <div class="hover_hand" :class="{'active': activeId == item.id}">{{item1.name}}</div>
					</div>
		        </div>
		    </div>
		</div-->
		<div class="role">
		    <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">区部</div>
			<span  class="hover_hand fill icon iconfont icon-jia" @click.stop="addTissue">添加部门</span>
		    <div style="border: 1px solid #EEEEEE; border-radius: 10px;">
		        <div v-for="(item,index) in departmentList[0].children" :key="index"
		             @click="chooseDepartment" :data-id="item.id"
					 :style="{'border-bottom': (index != departmentList.length - 1 ? '1px solid #eeeeee' : '')}"
		             style=" ">
		            <div class="hover_hand">{{item.name}}</div>
					<div v-for="(item1,index1) in item.children" :key="index1"
					     @click="chooseDepartment" :data-team_id="item1.id"
						 :style="{'border-bottom': (index != departmentList.length - 1 ? '1px solid #eeeeee' : '')}"
					     style="display: flex; justify-content: space-between; align-items: center; padding: 20px; ">
						 <div class="hover_hand" :class="{'active': activeId == item1.id}">{{item1.name}}</div>
					</div>
		        </div>
		    </div>
		</div>
        <!-- 操作日志 -->
        <div class="operation_log">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">操作日志</div>
            <Timeline>
                <TimelineItem v-for="item in logList">
                    <p class="time">{{item.created_at}}</p>
                    <p class="content">{{item.ext_info.remark}}</p>
                </TimelineItem>
            </Timeline>
        </div>
        <!-- 编辑对话框 -->
        <Modal v-model="editTissueShow" width='400' @on-ok="editOkClick">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">编辑</div>
            <Form :model="editTissueItem" :label-width="80">
                <FormItem label="部门名称">
                    <Input v-model="editTissueItem.name" placeholder="请输入部门名称"></Input>
                </FormItem>
            </Form>
        </Modal>
        <!-- 新建对话框 -->
        <Modal v-model="addTissueShow" width='400' @on-ok="addOkClick">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">新建</div>
            <Form :model="addTissueItem" :label-width="90">
                <FormItem label="部门名称">
                    <Input v-model="addTissueItem.name" placeholder="请输入部门名称"></Input>
                </FormItem>
				<Select  style="width:150px" placeholder="请选择品牌负责人">
					<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {
        saveDepartment,delDepartment
    } from '@/api/user'
    export default {
        name: "Tissue",
        props: {
            'departmentList': {

            },
            'logList': {
                type: Array
            }
        },
        data() {
            return {
                editTissueShow: false,//编辑对话框显示
                addTissueShow: false,//新建对话框显示
                editTissueItem: {
                    id: 0,
                    name: ''
                },
                addTissueItem: {
                    name: ''
                },
                activeId: '',
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        methods: {
            editTissue(e) {
                this.editTissueShow = true
                this.editTissueItem.id = e.currentTarget.dataset.id
                this.editTissueItem.name = e.currentTarget.dataset.name
            },
            // 编辑确定按钮
            editOkClick() {
                let that = this;
                let data = {token: this.token, name:this.editTissueItem.name, id:this.editTissueItem.id};
                this.throttle(async function () {
                    let res = await saveDepartment(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('loadData')
                    }
                }, 2000)
            },
            // 新建按钮
            addTissue() {
                this.addTissueShow = true
            },
            // 新建确定按钮
            addOkClick() {
                let that = this;
                let data = {token: this.token, name:this.addTissueItem.name};
                this.throttle(async function () {
                    let res = await saveDepartment(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('loadData')
                    }
                }, 2000)
            },
            chooseDepartment(e) {
                this.activeId = e.currentTarget.dataset.id
                this.$emit('getMemberList');
            },
            delTissue(e) {
                let that = this;
                let id = e.currentTarget.dataset.id
                let data = {token: this.token, id:id};
                this.throttle(async function () {
                    let res = await delDepartment(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('loadData')
                    }
                }, 2000)
            }
        }
    }
</script>

<style scoped lang="less">
    .role {
        width: 325px;
        background-color: #FFFFFF;
        padding: 20px;
    }

    .operation_log {
        margin-top: 20px;
        width: 325px;
        background-color: #FFFFFF;
        padding: 20px;
    }

    .fill {
        color: #DCDEE2;
        font-size: 18px;
        margin: 0 5px;
    }

    .hover_hand {
        cursor: pointer;
    }

    .hover_hand:hover {
        color: #277dd3;
    }
    .active{
        color: #54A1F3;
    }
</style>
